import { render, staticRenderFns } from "./aiOne.vue?vue&type=template&id=3f572c24&scoped=true&"
import script from "./aiOne.vue?vue&type=script&lang=js&"
export * from "./aiOne.vue?vue&type=script&lang=js&"
import style0 from "./aiOne.vue?vue&type=style&index=0&id=3f572c24&lang=less&scoped=true&"
import style1 from "./aiOne.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f572c24",
  null
  
)

export default component.exports